import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const typeMap = {
  success: { 
    icon: 'circle-check', 
    className: 'bg-emerald-50 text-emerald-800 dark:bg-emerald-500/10 dark:text-emerald-200 border-emerald-200/40' 
  },
  warning: { 
    icon: 'exclamation-triangle', 
    className: 'bg-amber-50 text-amber-800 dark:bg-amber-500/10 dark:text-amber-200 border-amber-200/40' 
  },
  danger: { 
    icon: 'triangle-exclamation', 
    className: 'bg-rose-50 text-rose-800 dark:bg-rose-500/10 dark:text-rose-200 border-rose-200/40' 
  },
  info: { 
    icon: 'circle-info', 
    className: 'bg-blue-50 text-blue-800 dark:bg-blue-500/10 dark:text-blue-200 border-blue-200/40' 
  },
};

const NotificationsPanel = ({ notifications = [] }) => {
  if (!notifications.length) return null;

  return (
    <div className="space-y-3">
      {notifications.map((notif) => {
        const meta = typeMap[notif.type] || typeMap.info;
        return (
          <div
            key={notif.id}
            className={`rounded-2xl border px-4 py-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between ${meta.className}`}
          >
            <div className="flex items-start gap-3">
              <FontAwesomeIcon icon={meta.icon} className="mt-1" />
              <div>
                <p className="font-semibold">{notif.title}</p>
                <p className="text-sm">{notif.message}</p>
              </div>
            </div>
            {notif.actionLabel && (
              <button
                type="button"
                onClick={notif.onAction}
                className="self-start sm:self-auto text-sm font-semibold underline offset-2"
              >
                {notif.actionLabel}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default NotificationsPanel;
